import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import ComponentHeader from '../../../common/ComponentHeader';
import { messages } from '../../../common/messages';
import LoaderWrapper from '../../../Components-2025/QuestionBank/LoaderWrapper';
import postApiService from '../../RestAPI/fetchData';
import config from '../../config/App_data';
import appRoutes from '../../config/AppRoutes';
/* eslint-disable */

export class PathwayList extends Component {
  static contextTypes = { router: React.PropTypes.object };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      list: [],
    };
  }
  componentDidMount() {
    this.fetchPathwayList();
  }

  fetchPathwayList = async () => {
    const { success = false, data = [] } = await postApiService.callAPI(
      `${config.backend_api}/cfa3PathwayExams/getPathways`,
    );
    if (success) {
      this.setState({ list: data, isLoading: false });
    } else {
      this.setState({ isLoading: false });
    }
  };
  render() {
    const { list, isLoading } = this.state;
    const { router } = this.context;

    return (
      <div className='animated fadeIn'>
        <ComponentHeader title={messages.PATHWAY_EXAM} />
        <LoaderWrapper isLoading={isLoading}>
          <Row>
            <Col md={12}>
              <div className='card height_70vh'>
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='90'>#</th>
                          <th className='mw-190'>{messages.PATHWAY_EXAM_LIST}</th>
                          <th className='w-280 text-center'>{messages.ACTION}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length ? (
                          list.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.id}</td>
                                <td>
                                  <div>{item.cbt_mock_exam_name} - {item.pathway_name}</div>
                                </td>
                                <td className='text-center'>
                                  <span
                                    className='btn btn-primary pointer_class small-btn tooltip_wrap '
                                    onClick={() =>
                                      router.push({
                                        pathname: appRoutes.CFA3_PATHWAY_SESSION.replace(
                                          ':pathway',
                                          item.id,
                                        ),
                                      })
                                    }
                                  >
                                    {messages.START}
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan='4' className='text-center py-4 px-2'>
                              <div className='no-qus-found no-mock-exam'>
                                <img
                                  width='80px'
                                  src={`${config.frontend_url}/img/questions/problem.png`}
                                />
                                <h3>{messages.PATHWAY_NOT_FOUND}</h3>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </LoaderWrapper>
      </div>
    );
  }
}

export default PathwayList;



// WEBPACK FOOTER //
// ./src/views/CBT/pathway/Pathway.js